import { Spinner } from "@/components/ui/misc";

export function FullPageSpinner() {
  return (
    <div className="flex h-dvh items-center justify-center">
      <Spinner />
    </div>
  );
}
